export const countryToCurrency = {
  AT: 'EUR',
  BE: 'EUR',
  BG: 'EUR',
  CY: 'EUR',
  CZ: 'EUR',
  DE: 'EUR',
  DK: 'EUR',
  EE: 'EUR',
  ES: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  GR: 'EUR',
  HR: 'EUR',
  HU: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  LV: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  PL: 'EUR',
  PT: 'EUR',
  RO: 'EUR',
  SE: 'EUR',
  SI: 'EUR',
  SK: 'EUR',
  AU: 'AUD',
  CA: 'CAD',
  CH: 'CHF',
  CN: 'CNY',
  GB: 'GBP',
  HK: 'HKD',
  JP: 'JPY',
  NZ: 'NZD',
  SG: 'USD',
  US: 'USD',
  ZA: 'ZAR',
  IN: 'USD',
} as const;

export type Currency = keyof typeof countryToCurrency;
